export enum LsKeys {
  TOKEN_INFO = 'on-ward.token-info',
}
